/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadingTwo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 18V6h2v5h6V6h2v12h-2v-5H5v5zm12.204 0v-1.26l2.184-2.4c.424-.464.752-.84.984-1.128.24-.296.408-.544.504-.744.096-.208.144-.4.144-.576 0-.728-.46-1.092-1.38-1.092-.648 0-1.384.22-2.208.66V9.852c.376-.192.78-.34 1.212-.444.44-.112.868-.168 1.284-.168.928 0 1.648.212 2.16.636s.768 1.028.768 1.812c0 .32-.064.64-.192.96s-.34.68-.636 1.08c-.288.392-.68.864-1.176 1.416l-1.212 1.332h3.24V18z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeadingTwo as HeadingTwo };
